import { Card, Col, Row, Table } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CommonTableComponentProp } from "../../../../Type/BootstrapTable";

export const CommonTableComponent = ({ title, data, tableClass }: CommonTableComponentProp) => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={title} />
        <div className="pt-3">
          <Row className="card-block">
            <Col sm="12" lg="12" xl="12">
              <div className="table-responsive theme-scrollbar">
                <Table className={tableClass} bordered>
                  <tbody>
                    {data.map((component, index) => (
                      <tr key={index}>
                        <td className={component.tdClassName}>{component.tittle}</td>
                        <td className="w-50">{component.tableColData}</td>
                        <td>
                          {component.details.map((detail: any, index: number) => (
                            <span key={index}>
                              {detail.text}
                              {detail.code && <code> {detail.code} </code>}
                            </span>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </Col>
  );
};
